// © 2015-2021 WDNA - All Rights Reserved
import { UserDO } from 'wdna-components';

import { authorization } from '../../user/requests';

/**
 * Function to perform the user login action
 *
 * @param type type of the login to performs
 * @param email email of the user to perform
 * @param password password of the user to perform
 * @returns response with the message of action
 */
export function loginUser(type: string, email: string, password: string): Promise<UserDO> | undefined {
  const formData: FormData = new FormData();
  formData.append('type', type);
  formData.append('email', email);
  formData.append('password', password);
  const options: Record<string, any> = { headers: { 'Content-Type': 'multipart/form-data' } };

  return authorization<UserDO>('login', formData, options);
}

/**
 * Functon to perform user logout action
 *
 * @returns response with the message of action
 */
export function logoutUser(): Promise<any> | undefined {
  return authorization('logout');
}
